/* globals userRolesAuth */
import intl from 'react-intl-universal'

import { hasPermission } from '../services/permission'
import CONSTANTS from '~/constants'

export default ['$http', '$q', 'storyService', 'toastr', publish]

function publish($http, $q, storyService, toastr) {
  this.getPublishState = () => storyService.getStoryPublishState()

  this.checkPubPerms = () =>
    this.getPublishState().then((state) => {
      const isValid =
        typeof userRolesAuth !== 'undefined' && // this is the canPublish from the pub actions directive
        userRolesAuth.story &&
        (hasPermission(userRolesAuth.story.publish) ||
          (!state.isPublished &&
            hasPermission(userRolesAuth.story.initialPublish)) ||
          (state.isPublished &&
            hasPermission(userRolesAuth.story.subsequentPublish)))
      if (!isValid) {
        const action = state.isPublished ? 1 : 0
        toastr.error(
          intl.get('publish.checkPubPerms.error', { action: action })
        )
        // throw new Error('This user is not authorized for initial publishing')
      }
      return isValid
    })

  this.getScheduledState = (id) => {
    var deferred = $q.defer()

    // not all orgs can schedule, this checks to see if they have the ability
    var canSchedule = false
    if (userRolesAuth.org && userRolesAuth.org.schedule_publish) {
      canSchedule = true
    }

    // If a new story, do not run the check.
    if (!id || !canSchedule) {
      return deferred.promise
    }

    const req = {
      method: 'GET',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/schedule/` + id,
      timeout: 20000,
    }

    $http(req).then(
      (response) => {
        console.log('schedule Success', response)
        const result = response.data
        const schedulePublish =
          result.schedule &&
          result.schedule.filter((msg) => msg.job_type === 'publish')
        const isScheduled = schedulePublish && schedulePublish.length
        const schedule = {
          isScheduledPublish: isScheduled,
          scheduled_publish_date: isScheduled
            ? new Date(schedulePublish[0].date)
            : null,
        }
        deferred.resolve(schedule)
      },
      (...args) => {
        console.log('schedule Failure', args)
        deferred.reject()
      }
    )

    return deferred.promise
  }

  this.publish = function(details) {
    const defaults = {
      edition: 'default',
    }

    const settings = Object.assign({}, defaults, details)
    const publishData = {
      revision_id: details.revision_id,
    }

    if (details.display_date) {
      publishData.display_date = new Date(settings.display_date).toISOString()
    }

    const req = {
      method: 'PUT',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/publish/` +
        settings._id +
        '/edition/' +
        settings.edition,
      data: publishData,
      timeout: 20000,
    }

    return this.checkPubPerms()
      .then(() => $http(req))
      .then(
        (...args) => {
          console.log('Publish Success', args)
          return args[0]
        },
        (...args) => {
          console.log('Publish Failure', args)
          throw args[0] // throw, not return, to reject downstream.
        }
      )
  }

  this.unpublish = function(details) {
    if (!hasPermission(userRolesAuth.story.unpublish)) {
      // notAuthorized(lang_phrases.auth.unpublish);
      return
    }

    const defaults = {
      edition: 'default',
    }

    const settings = Object.assign({}, defaults, details)

    const req = {
      method: 'DELETE',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/publish/` +
        settings._id +
        '/edition/' +
        settings.edition,
      timeout: 20000,
    }

    return $http(req).then(
      (...args) => {
        console.log('Unpublish Success', args)
      },
      (...args) => {
        console.log('Unpublish Failure', args)
      }
    )
  }

  this.schedule = function(details) {
    const defaults = {
      edition: 'default',
    }

    const settings = Object.assign({}, defaults, details)
    const scheduledData = {
      revision_id: details.revision_id,
      scheduleDateTime: new Date(settings.scheduleDateTime).toISOString(),
    }

    if (details.display_date) {
      scheduledData.display_date = new Date(settings.display_date).toISOString()
    }

    const req = {
      method: 'PUT',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/schedule/` +
        settings._id +
        '/edition/' +
        settings.edition,
      data: scheduledData,
      timeout: 20000,
    }

    return $http(req)
  }

  this.unschedule = function(details) {
    if (!hasPermission(userRolesAuth.story.unpublish)) {
      // notAuthorized(lang_phrases.auth.unpublish);
      return
    }

    const defaults = {
      edition: 'default',
    }

    const settings = Object.assign({}, defaults, details)

    const req = {
      method: 'DELETE',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/unschedule/` +
        settings._id +
        '/edition/' +
        settings.edition,
      timeout: 20000,
    }

    return $http(req).then(
      (...args) => {
        console.log('Unpublish Success', args)
      },
      (...args) => {
        console.log('Unpublish Failure', args)
      }
    )
  }

  this.scheduleUnpublish = function(details) {
    const { revision_id: revisionId } = details
    const defaults = {
      edition: 'default',
    }
    const options = Object.assign({}, defaults, details)
    const scheduledData = {
      revisionId: revisionId,
      scheduleDateTime: new Date(options.scheduleDateTime).toISOString(),
    }

    const req = {
      method: 'PUT',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/schedule_unpublish/` +
        options._id +
        '/edition/' +
        options.edition,
      data: scheduledData,
      timeout: 20000,
    }

    return $http(req)
  }

  this.unscheduleUnpublish = function(reqBody) {
    const req = {
      method: 'PUT',
      url:
        `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/unschedule_unpublish/` +
        reqBody.story_id +
        '/edition/default',
      data: reqBody,
      timeout: 20000,
    }

    return $http(req).then(
      (...args) => {
        console.log('Unschedule unpublish Success', args)
        return args[0]
      },
      (...args) => {
        console.log('Unschedule unpublish Failure', args)
      }
    )
  }
}
